import React, { FC } from 'react';
import './styles.scss';

const Spinner: FC<{ extraClassName?: string }> = ({ extraClassName = '' }) => (
  <div className={`spinner__wrapper ${extraClassName}`}>
    <div className="spinner">
      <svg className="spinner__circle" viewBox="25 25 50 50">
        <circle className="spinner__path" cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10"></circle>
      </svg>
    </div>
  </div>
);

export default Spinner;
